import Decimal from 'decimal.js'

export type TParcelaComQuantidade = {
  valor: number | string
  quantidade: number
}

type TAgruparParcelasInput = {
  valor?: number | string | null
  quantidade?: number | null
  parcelas?: unknown[] | null
}

export const agruparParcelasComQuantidade = (
  itens: Array<TAgruparParcelasInput | null | undefined> | undefined,
): Array<{ valor: number; quantidade: number }> =>
  (itens ?? []).map((item) => ({
    valor: Number(item?.valor ?? 0),
    quantidade: Array.isArray(item?.parcelas) ? item.parcelas.length : Number(item?.quantidade ?? 0),
  }))

export const calcularTotalParcelasComJuros = (parcelas: Array<TParcelaComQuantidade | null | undefined> | undefined) =>
  (parcelas ?? [])
    .reduce(
      (acc, parcela) => acc.plus(new Decimal(parcela?.valor ?? 0).times(parcela?.quantidade ?? 0)),
      new Decimal(0),
    )
    .toNumber()
